// src/components/templates/MainTemplate.tsx
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { FiX } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

import Header from '../organisms/Header/Header';
import Footer from '../organisms/Footer/Footer';
import MobileMenu from '../organisms/MobileMenu/MobileMenu';
import MiraiBooking from '../atoms/MiraiBooking/MiraiBooking';
import MiraiSession from '../atoms/MiraiSesion/MiraiSession';

import './MainTemplate.css';

const MainTemplate: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false); // Nuevo estado

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const openBooking = () => setIsBookingOpen(true);
  const openLogin = () => setIsLoginOpen(true); // Nueva función

  return (
    <div className="app-layout relative">

      <Header
        toggleMenu={toggleMenu}
        onReserveClick={openBooking}
        onLoginClick={openLogin} // Prop nueva
      />

      <MobileMenu
        isOpen={isMenuOpen}
        toggleMenu={toggleMenu}
        onReserveClick={openBooking}
        onLoginClick={openLogin} // Prop nueva
      />

      <main className="page-content">
        {/* Pasamos ambas funciones al contexto */}
        <Outlet context={{ openBooking, openLogin }} />
      </main>

      {/* MODAL DE RESERVA */}
      <div className={`booking-modal-overlay ${isBookingOpen ? 'open' : ''}`}>
        <div className="booking-modal-content">
          <button
            className="booking-close-btn"
            onClick={() => setIsBookingOpen(false)}
            aria-label="Cerrar reserva"
          >
            <FiX />
          </button>
          <MiraiBooking hotelId="100376918" />
        </div>
        <div className="absolute inset-0 -z-10" onClick={() => setIsBookingOpen(false)}></div>
      </div>

      {/* MODAL DE LOGIN (SESSION) */}
      <div className={`booking-modal-overlay ${isLoginOpen ? 'open' : ''}`}>
        <div className="booking-modal-content">
          <button
            className="booking-close-btn"
            onClick={() => setIsLoginOpen(false)}
            aria-label="Cerrar sesión"
          >
            <FiX />
          </button>
          <MiraiSession hotelId="100376918" />
        </div>
        <div className="absolute inset-0 -z-10" onClick={() => setIsLoginOpen(false)}></div>
      </div>

      <Footer />
    </div>
  );
};

export default MainTemplate;